import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/reducer/rootReducer";
import { getMe } from "./protectedService";
import { User } from "../../utils/types/user";
import { useDispatch } from "react-redux";
import { setUser } from "../../redux/action/userAction";
import { Spinner } from "@chakra-ui/react"; // Use any loading spinner you like


interface ProtectedRouteProps {
  children: any;
}

const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(true); // Loading state
  const user = useSelector((state: RootState) => state.user);
  const token = localStorage.getItem("token");

  useEffect(() => {

       checkUserFromToken();
  }, []);

  const checkUserFromToken = async () => {
    if (!token) {
      navigate("/login");
    } else {
      const response = await getMe(token);
      if (response.success) {
        console.log("User: ", response.data);
        dispatch(setUser(response.data as User) as any);
      } else {
        localStorage.setItem("token", "");
        navigate("/login");
      }
    }
    setIsLoading(false);
  };
  if (isLoading) {
    return (
      <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
        <Spinner size="xl" />
      </div>
    );
  }

  return children;
};

export default ProtectedRoute;
